module.exports = __webpack_public_path__ + "static/media/chart-pie.0125b596.svg";